import { IApiRes } from "../types/interfaces";

interface IUnwrapIsSuccess extends IApiRes {
    data: unknown;
}
export const isResponseSuccess = (res: IUnwrapIsSuccess) => {
    return res?.status === 1 && res?.message === "success" && res?.data;
};
